import { render, staticRenderFns } from "./DeliveryCompanyListView.vue?vue&type=template&id=21a6fb60&scoped=true&"
import script from "./DeliveryCompanyListView.vue?vue&type=script&lang=js&"
export * from "./DeliveryCompanyListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a6fb60",
  null
  
)

export default component.exports